module.exports = __webpack_public_path__ + "static/media/wexp.9425c5e5.png";